import React, { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function Bulk() {
  const [f, setF] = useState({ company: "", name: "", email: "", phone: "", quantity: 25, material: "Walnut", details: "" });
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/bulk-quote", { ...f, quantity: parseInt(f.quantity) || 25 }); toast.success("Quote request received. We'll respond within one business day."); setF({ company: "", name: "", email: "", phone: "", quantity: 25, material: "Walnut", details: "" }); }
    catch { toast.error("Could not send request"); }
  };
  return (
    <div data-testid="bulk-page" className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
      <div className="uppercase text-xs tracking-[0.3em] font-bold" style={{color: "var(--secondary)"}}>Bulk & Business</div>
      <h1 className="font-serif text-5xl sm:text-6xl mt-3 leading-none" style={{color: "var(--primary)"}}>For orders of ten and beyond.</h1>
      <p className="mt-4 max-w-xl text-[color:var(--text-muted)]">Corporate gifting, event awards, retailer runs, branded signage — we scale with volume pricing and dedicated project management.</p>
      <form onSubmit={submit} data-testid="bulk-form" className="mt-10 bg-white rounded-lg border hairline p-8 space-y-6">
        <div className="grid sm:grid-cols-2 gap-5">
          <div><Label>Company</Label><Input data-testid="bulk-company" required value={f.company} onChange={(e) => setF({...f, company: e.target.value})}/></div>
          <div><Label>Contact name</Label><Input data-testid="bulk-name" required value={f.name} onChange={(e) => setF({...f, name: e.target.value})}/></div>
          <div><Label>Email</Label><Input data-testid="bulk-email" type="email" required value={f.email} onChange={(e) => setF({...f, email: e.target.value})}/></div>
          <div><Label>Phone</Label><Input data-testid="bulk-phone" value={f.phone} onChange={(e) => setF({...f, phone: e.target.value})}/></div>
          <div><Label>Quantity</Label><Input data-testid="bulk-quantity" type="number" min={10} value={f.quantity} onChange={(e) => setF({...f, quantity: e.target.value})}/></div>
          <div><Label>Material preference</Label><Input data-testid="bulk-material" value={f.material} onChange={(e) => setF({...f, material: e.target.value})}/></div>
        </div>
        <div><Label>Project details</Label><Textarea data-testid="bulk-details" required rows={5} value={f.details} onChange={(e) => setF({...f, details: e.target.value})}/></div>
        <Button data-testid="bulk-submit" type="submit" className="btn-primary rounded-full px-8 py-6">Request a quote</Button>
      </form>
    </div>
  );
}
